/**
 * Select FREE plan
 * Registers user as FREE plan without payment
 * @param accessAuthToken - Auth0 access token
 * @returns Success status and message
 */
export const selectFreePlan = async (accessAuthToken: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/payments/select-free-plan`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to select FREE plan");
    }

    return await response.json();
  } catch (error: any) {
    console.error("❌ Error selecting FREE plan:", error.message);
    throw error;
  }
};
